import { Component, inject, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalImageLandingComponent } from '../../../features/product/page/components/modal-image-landing/modal-image-landing.component';

@Component({
  selector: 'app-carousel',
  imports: [],
  templateUrl: './carousel.component.html',
  styleUrl: './carousel.component.scss',
  standalone: true
})
export class CarouselComponent implements OnInit {
  @Input() item;

  private modalService = inject(NgbModal);

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.item = this.item.filter(a => a.size === 1000)

  }

  opemViewImg(img: any) {
    const modalRef = this.modalService.open(ModalImageLandingComponent, { size: 'lg' });
    modalRef.componentInstance.img = img;
  }
}
